import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import ReactGA from 'react-ga4'

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID, {
    gaOptions: {
      // The admin UI is served in a cross-site iframe inside Shopify admin, so the
      // browser drops GA's _ga / _ga_<id> cookies with the default Lax flag. Those
      // cookies hold the session id and engagement state, so without them hits
      // arrive but never group into sessions. Partitioned keeps them working where
      // third-party cookies are blocked outright.
      cookieFlags: 'SameSite=None;Secure;Partitioned',
    },
    gtagOptions: {
      // Router owns every pageview, including the first one.
      send_page_view: false,
    },
  })
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

if (process.env.NODE_ENV === 'production') {
  const tawkScript = document.createElement('script')
  tawkScript.type = 'text/javascript'
  tawkScript.async = true
  tawkScript.innerHTML = `
    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    (function(){
    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    s1.async=true;
    s1.src='https://embed.tawk.to/60ef363c649e0a0a5ccc3b73/1faj6nmt6';
    s1.charset='UTF-8';
    s1.setAttribute('crossorigin','*');
    s0.parentNode.insertBefore(s1,s0);
    })();
  `
  document.body.appendChild(tawkScript)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
